import React from 'react';
import { motion } from 'framer-motion';

const PathwaysLogo = ({ size = 'md', animated = true, showText = true }) => {
  const sizes = {
    sm: { logo: 'h-8 sm:h-10', text: 'text-lg sm:text-xl' },
    md: { logo: 'h-10 sm:h-12 md:h-16', text: 'text-xl sm:text-2xl md:text-3xl' },
    lg: { logo: 'h-12 sm:h-16 md:h-20', text: 'text-2xl sm:text-3xl md:text-4xl' },
  };

  return (
    <motion.div
      initial={animated ? { opacity: 0, scale: 0.8 } : {}}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 20 }}
      className="flex items-center gap-2 sm:gap-3"
    >
      <img 
        src="/pathways-logo.png" 
        alt="Pathways Logo" 
        className={`${sizes[size].logo} w-auto object-cover rounded-full border-2 sm:border-3 border-ssdp-navy shadow-[3px_3px_0px_0px_rgba(30,58,89,1)] sm:shadow-[4px_4px_0px_0px_rgba(30,58,89,1)]`}
        style={{ maxWidth: '80px', aspectRatio: '1/1' }}
      />
      {showText && (
        <h1 className={`${sizes[size].text} font-black text-ssdp-navy font-heading tracking-tight`}>
          Pathways
        </h1>
      )}
    </motion.div>
  );
};

export default PathwaysLogo;
